import {Box, Typography} from '@mui/material';
import {NavigateBefore, NavigateNext} from '@mui/icons-material';
import styles from './DataTable.module.scss';
import { PaginationSetup } from '../../../../common/Interfaces';
import { getMaximumRowsPerPage } from '../../../../common/Utils';
import BorderlessButton from '../buttons/BordlessButton';
import { useTranslation } from 'react-i18next';
import CustomChip from '../../customChip/CustomChip';

export default function PaginationControl (paginationData?: PaginationSetup) {
    const {t} = useTranslation();

    const pageIndex = paginationData?.currentPage ?? 0;
    const page = pageIndex + 1;
    const numberOfPages = (paginationData?.dataCount ?? 0) / getMaximumRowsPerPage();
    const lastPage = Number.isInteger(numberOfPages)
    ? numberOfPages
    : numberOfPages <= 0
    ? 1
    : Math.trunc(numberOfPages) + 1;

    const noData = paginationData?.dataCount ? paginationData?.dataCount === 0 : true;

    return paginationData ? (
            <Box className={[styles.fullwidth, styles.paginationContainer].join(" ")}>
                {pageIndex > 0 && (
                    <Box className={styles.paginationContainer}>
                        <BorderlessButton
                            onclickHandler={() => paginationData.setCurrentPage(0)} 
                            id={'FirstPageButton'} 
                            label={
                                <Box className={styles.horizontalContainer}>
                                    <NavigateBefore className="text-xs" />{' '}
                                    <NavigateBefore className="text-xs" />{' '}
                                    {t("FIRST")}
                                </Box>
                            }
                            customStyle={{
                                color: '#10366E',
                            }}
                        />

                        <BorderlessButton
                            onclickHandler={() => paginationData.setCurrentPage(pageIndex - 1)} 
                            id={'PreviousPageButton'} 
                            label={
                                <Box className={styles.horizontalContainer}>
                                    <NavigateBefore className="text-xs" />{' '}
                                    {t("PREVIOUS")}
                                </Box>
                            }
                            customStyle={{
                                color: '#10366E',
                            }}
                        />
                    </Box>
                )}

                <CustomChip label={`${page} - ${lastPage === 0 ? 1 : lastPage}`}/>

                {!(page === lastPage || noData) && (
                    <Box className={styles.paginationContainer}>
                        <BorderlessButton
                            onclickHandler={() => paginationData.setCurrentPage(pageIndex + 1)} 
                            id={'NextPageButton'} 
                            label={
                                <Box className={styles.horizontalContainer}>
                                    {t("NEXT")}
                                    <NavigateNext className="text-xs" />{' '}
                                </Box>
                            }
                            customStyle={{
                                color: '#10366E',
                            }}
                        />

                        <BorderlessButton
                            onclickHandler={() => paginationData.setCurrentPage(lastPage - 1)} 
                            id={'LastPageButton'} 
                            label={
                                <Box className={styles.horizontalContainer}>
                                    {t("LAST")}
                                    <NavigateNext className="text-xs" />{' '}
                                    <NavigateNext className="text-xs" />{' '}
                                </Box>
                            }
                            customStyle={{
                                color: '#10366E',
                            }}
                        />
                    </Box>
                )}
            </Box>
        ): 
        (<div/>);
}